<button
  mat-icon-button
  [matTooltipPosition]="tooltipPosition"
  [matTooltip]="state.isActive ? 'Close Asset' : 'Open Asset'"
  class="button-open-in-sidebar"
  [class.active]="state.isActive"
  [attr.data-test]="'button-open-in-sidebar-' + path"
  (click)="openInAssetSidebar($event)"
>
  <fa-icon class="fs-08" [icon]="['fal', 'sidebar-flip']"></fa-icon>
</button>
